/* Baby range product data (Laura's 12 July build, Kids Shampoo & Conditioner renamed 16 Oct 2026 to match the new label). */
window.TN_PRODUCTS=[{id:"koala",animal:"Koala",buddy:"Koko",bio:"The sleepy one. Koko runs the evening wind down, with warm water, lavender, heavy eyelids. Asleep before the towel comes out.",name:"Baby Wash",scent:"Chamomile & Lavender",size:"500mL",price:"$21.95",url:"https://trinature.com.au/collections/baby-kids-care/products/baby-wash?variant=53150248894827",line:"A calming wash for warm evening baths, with chamomile and lavender to settle little ones before sleep.",bottle:"assets/bottles/bottle-koala.png",cutout:"assets/animals/koala.png",peek:{side:"right",rise:46}},{id:"kangaroo",animal:"Kangaroo",buddy:"Katie",bio:"Big sibling energy. Katie bounces in first, checks the water, and stays close until everyone\u2019s clean, dry and accounted for.",name:"Baby Wash",scent:"Vanilla & Oatmeal",size:"500mL",price:"$21.95",url:"https://trinature.com.au/collections/baby-kids-care/products/baby-wash?variant=53150248862059",line:"A soft milk wash designed to pamper baby\u2019s delicate skin leaving it soft and clean.",bottle:"assets/bottles/bottle-kangaroo.png",cutout:"assets/animals/kangaroo.png",peek:{side:"left",rise:50}},{id:"galah",animal:"Galah",buddy:"Gabe",bio:"The entertainer. Gabe believes there is no such thing as too many bubbles and will argue the point loudly, nightly.",name:"Kids Bubble Bath & Wash",scent:"Cherry Blossom",size:"500mL",price:"$19.95",url:"https://trinature.com.au/collections/baby-kids-care/products/kids-bubble-bath-and-wash-cherry-blossom?variant=53285131714923",line:"Mountains of gentle bubbles, scented with cherry blossom. Bath time\u2019s new best friend.",bottle:"assets/bottles/bottle-galah.png",cutout:"assets/animals/galah.png",peek:{side:"right",rise:48}},{id:"quokka",animal:"Quokka",buddy:"Quincy",bio:"The smiley one. Quincy has never met a tangle she couldn\u2019t talk out of a knot. No tears, promise, it\u2019s her whole thing.",name:"Kids Shampoo & Conditioner",scent:"Pear & Raspberry",size:"500mL",price:"$21.95",url:"https://trinature.com.au/collections/baby-kids-care/products/kids-2-in-1-shampoo-conditioner?variant=53150232543595",line:"One pump, no tears, no tangles. Pear and raspberry softness from tub to towel.",bottle:"assets/bottles/bottle-quokka.png",cutout:"assets/animals/quokka.png",peek:{side:"left",rise:44}},{id:"platypus",animal:"Platypus",buddy:"Pearl",bio:"The quiet water baby. Pearl likes slow mornings, warm hands and long cuddles, keeping the calm moments calm.",name:"Mum & Baby Massage Oil",scent:"Chamomile & Lavender",size:"200mL",price:"$29.95",url:"https://trinature.com.au/collections/baby-kids-care/products/baby-massage-oil?variant=53150238245227",line:"For quiet moments together. A light, nourishing oil for mum\u2019s skin and baby\u2019s, too.",bottle:"assets/bottles/bottle-platypus.png",cutout:"assets/animals/platypus.png",peek:{side:"right",rise:40}}];
window.TN_COLLECTION_URL="https://trinature.com.au/collections/baby-kids-care";

/* ─────────────────────────────────────────────────────────────────────────
   Tri Nature baby range page: cart, subscribe options and the gift box buy box.
   Fallon Digital, 16 October 2026. Replaces the 5 August cart fix.

   Loaded by templates/page.baby-range.liquid BEFORE the page's own build
   script, so everything here waits for DOMContentLoaded, by which time the
   product cards (#drops) and the gift box section (#bundle) exist.

   What it does
   1. Add to cart on every product card reaches the real Shopify cart.
   2. Every product card gets One time or Subscribe, with every 4, 8 or 12
      weeks. Plans and prices are read live from /products/<handle>.js, so
      nothing here needs editing when Appstle prices change. Plans with
      "Business" in the name are trade plans and are never offered here.
   3. The Baby Shower Gift Box section becomes a buy box: the open box photo,
      a scent choice, One time or Subscribe, and Add to cart. The Subscribe
      option only appears once the gift boxes are in an Appstle plan, so it
      switches itself on when Laura adds them in Appstle.
   4. On /pages/baby-range-business only point 1 runs. No subscribe, no
      gift box changes (bundles are retail only).

   Every add posts to /cart/add.js?appstle=true. Appstle's storefront script
   rewrites selling_plan on any /cart/add it did not make itself unless that
   flag is present (found 8 Sep 2026 on the product page).
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var ADD_URL = '/cart/add.js?appstle=true';
  var BUSINESS_PAGE = /baby-range-business/.test(window.location.pathname);
  var FREQS = ['4', '8', '12'];
  var DEFAULT_FREQ = '8';
  var MIN_NOTE = 'Subscriptions have a $40 minimum per delivery. Mix and match any products to reach it.';
  var GIFT_BOXES = [
    {
      key: 'chamomile',
      label: 'Chamomile & Lavender',
      handle: 'baby-bundle-chamomile-lavender',
      image: 'https://cdn.shopify.com/s/files/1/0979/2045/0923/files/tn-baby-shower-gift-box-chamomile-lavender.jpg?v=1792117113&width=1100'
    },
    {
      key: 'vanilla',
      label: 'Vanilla & Oatmeal',
      handle: 'baby-bundle-vanilla-oatmeal',
      image: 'https://cdn.shopify.com/s/files/1/0979/2045/0923/files/tn-baby-shower-gift-box-vanilla-oatmeal.jpg?v=1792117113&width=1100'
    }
  ];

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function findProduct(id) {
    var list = window.TN_PRODUCTS || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }

  function variantIdOf(p) {
    var m = String((p && p.url) || '').match(/variant=(\d+)/);
    return m ? m[1] : '';
  }

  function handleOf(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  var productCache = {};
  function loadProduct(handle) {
    if (!handle) return Promise.reject(new Error('no handle'));
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('product ' + handle + ' ' + r.status);
        return r.json();
      });
    }
    return productCache[handle];
  }

  /* Retail plans for one variant, keyed by weeks: { '8': { id, price } } */
  function retailPlans(product, variantId) {
    var out = {};
    var names = {};
    (product.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) { names[sp.id] = sp.name || ''; });
    });
    var variant = null;
    (product.variants || []).forEach(function (v) {
      if (String(v.id) === String(variantId)) variant = v;
    });
    if (!variant) return { variant: null, plans: out };
    (variant.selling_plan_allocations || []).forEach(function (a) {
      var name = names[a.selling_plan_id] || '';
      if (/business/i.test(name)) return;
      var m = name.match(/(\d+)\s*week/i);
      if (!m || FREQS.indexOf(m[1]) === -1) return;
      out[m[1]] = { id: a.selling_plan_id, price: a.price };
    });
    return { variant: variant, plans: out };
  }

  function hasPlans(plans) {
    return Object.keys(plans || {}).length > 0;
  }

  function addToCart(variantId, planId) {
    var item = { id: Number(variantId), quantity: 1 };
    if (planId) item.selling_plan = Number(planId);
    return fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add to cart failed: ' + r.status);
      return r.json();
    });
  }

  function refreshBadge() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.getElementById('bagCount');
        var bag = document.getElementById('bagBtn');
        var n = cart.item_count || 0;
        if (badge) badge.textContent = n;
        if (bag) bag.classList.toggle('has', n > 0);
        return n;
      })
      .catch(function () { return null; });
  }

  function showToast(name, sub) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    var n = document.getElementById('toastName');
    var s = toast.querySelector('.t-sub');
    if (n) n.textContent = name;
    if (s) s.textContent = sub || 'Tap the bag to check out';
    toast.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  /* ── styles for the new controls, matched to the page's own tokens ── */
  function injectStyles() {
    if (document.getElementById('tn-baby-subscribe-css')) return;
    var css = [
      '.tnpo{display:flex;flex-direction:column;gap:10px;margin:16px 0 18px;}',
      '.tnpo-row{display:grid;grid-template-columns:1fr 1fr;gap:8px;}',
      '.tnpo-opt{display:flex;flex-direction:column;align-items:flex-start;gap:3px;padding:10px 14px;border:1.5px solid rgba(89,113,91,.32);border-radius:14px;background:#fff;font-family:var(--sans);font-size:10.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--ink-soft);cursor:pointer;text-align:left;line-height:1.35;transition:border-color .2s ease,box-shadow .2s ease,color .2s ease;}',
      '.tnpo-opt b{font-family:var(--serif);font-size:20px;font-weight:600;letter-spacing:0;text-transform:none;color:var(--ink);}',
      '.tnpo-opt[aria-pressed="true"]{border-color:var(--olive);box-shadow:inset 0 0 0 1px var(--olive);color:var(--olive);background:var(--white-warm);}',
      '.tnpo-opt:focus-visible,.tnpo-chip:focus-visible,.tngb-scent:focus-visible{outline:2px solid var(--sage);outline-offset:2px;}',
      '.tnpo-freq{display:flex;flex-wrap:wrap;align-items:center;gap:6px;}',
      '.tnpo[hidden],.tnpo-freq[hidden],.tnpo-note[hidden]{display:none;}',
      '.tnpo-freq-label{font-family:var(--sans);font-size:10.5px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--ink-soft);margin-right:2px;}',
      '.tnpo-chip{padding:7px 13px;border-radius:999px;border:1.5px solid rgba(89,113,91,.32);background:#fff;font-family:var(--sans);font-size:12px;font-weight:600;color:var(--ink-soft);cursor:pointer;}',
      '.tnpo-chip[aria-pressed="true"]{background:var(--olive);border-color:var(--olive);color:#fff;}',
      '.tnpo-note{margin:0;font-family:var(--sans);font-size:12px;line-height:1.6;color:var(--ink-soft);}',
      '.tngb-img{display:block;width:100%;max-width:520px;height:auto;margin:0 auto;aspect-ratio:1/1;object-fit:cover;border-radius:28px;box-shadow:0 18px 40px rgba(95,85,55,.16);background:#ecebe8;}',
      '.tngb-buy{display:flex;flex-direction:column;align-items:stretch;gap:12px;width:100%;max-width:440px;margin:0 auto;}',
      '.tngb-scents{display:grid;grid-template-columns:1fr 1fr;gap:8px;}',
      '.tngb-scent{padding:12px 10px;border-radius:999px;border:1.5px solid rgba(89,113,91,.32);background:#fff;font-family:var(--sans);font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--ink-soft);cursor:pointer;}',
      '.tngb-scent[aria-pressed="true"]{background:var(--olive);border-color:var(--olive);color:#fff;}',
      '.tngb-buy .tnpo{margin:4px 0 2px;}',
      '.tngb-add{width:100%;}',
      '.tngb-links{display:flex;justify-content:center;}',
      '.tngb-status{min-height:1.2em;margin:0;font-family:var(--sans);font-size:12px;color:var(--sage);text-align:center;}',
      '@media (max-width:760px){.drop .tnpo-opt{align-items:center;text-align:center;}.drop .tnpo-freq{justify-content:center;}.drop .tnpo-freq-label{flex-basis:100%;text-align:center;margin:0 0 2px;}.tnpo-note{text-align:center;}}',
      '@media (max-width:380px){.tnpo-row,.tngb-scents{grid-template-columns:1fr;}}'
    ].join('\n');
    var el = document.createElement('style');
    el.id = 'tn-baby-subscribe-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* ── One time / Subscribe control ──
     opts: { onceCents, plans, subLabel, note }
     Returns { el, mode(), planId(), update(onceCents, plans) } */
  var poCount = 0;
  function purchaseOptions(opts) {
    poCount += 1;
    var el = document.createElement('div');
    el.className = 'tnpo';
    el.setAttribute('role', 'group');
    el.setAttribute('aria-label', 'Purchase options');
    el.innerHTML =
      '<div class="tnpo-row">' +
        '<button type="button" class="tnpo-opt" data-mode="once" aria-pressed="true"><span>One time</span><b data-once></b></button>' +
        '<button type="button" class="tnpo-opt" data-mode="sub" aria-pressed="false"><span data-sublabel></span><b data-sub></b></button>' +
      '</div>' +
      '<div class="tnpo-freq" hidden><span class="tnpo-freq-label">Deliver every</span></div>' +
      '<p class="tnpo-note" hidden></p>';
    var freqEl = el.querySelector('.tnpo-freq');
    var noteEl = el.querySelector('.tnpo-note');
    var state = { mode: 'once', weeks: DEFAULT_FREQ, plans: {}, once: 0 };

    FREQS.forEach(function (w) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tnpo-chip';
      b.setAttribute('data-weeks', w);
      b.setAttribute('aria-pressed', w === DEFAULT_FREQ ? 'true' : 'false');
      b.textContent = w + ' weeks';
      freqEl.appendChild(b);
    });
    el.querySelector('[data-sublabel]').textContent = opts.subLabel;
    noteEl.textContent = opts.note;

    function render() {
      el.querySelector('[data-once]').textContent = money(state.once);
      var plan = state.plans[state.weeks] || state.plans[Object.keys(state.plans)[0]];
      el.querySelector('[data-sub]').textContent = plan ? money(plan.price) : '';
      Array.prototype.forEach.call(el.querySelectorAll('.tnpo-opt'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mode') === state.mode ? 'true' : 'false');
      });
      Array.prototype.forEach.call(el.querySelectorAll('.tnpo-chip'), function (b) {
        var w = b.getAttribute('data-weeks');
        b.hidden = !state.plans[w];
        b.setAttribute('aria-pressed', w === state.weeks ? 'true' : 'false');
      });
      freqEl.hidden = state.mode !== 'sub';
      noteEl.hidden = state.mode !== 'sub';
      el.setAttribute('data-mode', state.mode);
      if (typeof opts.onChange === 'function') opts.onChange(state.mode);
    }

    el.addEventListener('click', function (e) {
      var opt = e.target.closest ? e.target.closest('.tnpo-opt') : null;
      var chip = e.target.closest ? e.target.closest('.tnpo-chip') : null;
      if (opt) { state.mode = opt.getAttribute('data-mode'); render(); }
      if (chip) { state.weeks = chip.getAttribute('data-weeks'); render(); }
    });

    var api = {
      el: el,
      mode: function () { return hasPlans(state.plans) ? state.mode : 'once'; },
      planId: function () {
        if (api.mode() !== 'sub') return null;
        var plan = state.plans[state.weeks] || state.plans[Object.keys(state.plans)[0]];
        return plan ? plan.id : null;
      },
      update: function (onceCents, plans) {
        state.once = onceCents;
        state.plans = plans || {};
        if (!state.plans[state.weeks]) state.weeks = Object.keys(state.plans)[0] || DEFAULT_FREQ;
        if (!hasPlans(state.plans)) state.mode = 'once';
        el.hidden = !hasPlans(state.plans);
        render();
      }
    };
    api.update(opts.onceCents || 0, opts.plans || {});
    return api;
  }

  /* ── product cards ── */
  var cardOptions = {};

  function setupCards() {
    var drops = document.querySelectorAll('#drops .drop');
    Array.prototype.forEach.call(drops, function (card) {
      var p = findProduct(card.getAttribute('data-id'));
      var vid = variantIdOf(p);
      if (!p || !vid) return;
      loadProduct(handleOf(p.url)).then(function (product) {
        var info = retailPlans(product, vid);
        if (!info.variant) return;
        var priceEl = card.querySelector('.price');
        if (priceEl) priceEl.textContent = money(info.variant.price);
        if (!hasPlans(info.plans)) return;
        var btn = card.querySelector('.btn-bag');
        var po = purchaseOptions({
          onceCents: info.variant.price,
          plans: info.plans,
          subLabel: 'Subscribe, save 5%',
          note: 'Skip, change or cancel any time. ' + MIN_NOTE,
          onChange: function (mode) { if (btn) btn.textContent = mode === 'sub' ? 'Subscribe' : 'Add to cart'; }
        });
        var actions = card.querySelector('.actions');
        if (actions && actions.parentNode) actions.parentNode.insertBefore(po.el, actions);
        cardOptions[p.id] = po;
      }).catch(function () { /* card keeps one time add to cart */ });
    });
  }

  function bindCardAdds() {
    var drops = document.getElementById('drops');
    if (!drops) return;
    /* Capture phase, so the page's own fly to bag animation and toast still play. */
    drops.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.btn-bag') : null;
      if (!btn) return;
      var id = btn.getAttribute('data-id');
      var p = findProduct(id);
      var vid = variantIdOf(p);
      var url = p ? p.url : '';
      if (!vid) { if (url) window.location.href = url; return; }
      if (btn.getAttribute('data-busy') === '1') return;
      btn.setAttribute('data-busy', '1');
      var po = cardOptions[id];
      var planId = po ? po.planId() : null;
      /* The page's own handler resets the label to Add to cart after 2.4s, and its toast joins name and scent with a long dash. */
      setTimeout(function () {
        var t = document.getElementById('toastName');
        if (t) t.textContent = t.textContent.replace(/\s+\u2014\s+/, ', ');
      }, 0);
      setTimeout(function () {
        if (po && po.mode() === 'sub' && !btn.classList.contains('added')) btn.textContent = 'Subscribe';
      }, 2450);
      addToCart(vid, planId)
        .then(function () { return refreshBadge(); })
        .catch(function () { if (url) window.location.href = url; })
        .then(function () { btn.setAttribute('data-busy', '0'); });
    }, true);
  }

  /* ── gift box buy box ── */
  function setupGiftBox() {
    var section = document.getElementById('bundle');
    if (!section) return;
    var stage = section.querySelector('.bundle-stage');
    var copy = section.querySelector('.bundle-copy');
    var oldActions = copy ? copy.querySelector('.actions') : null;
    if (!stage || !copy || !oldActions) return;

    var current = GIFT_BOXES[1];
    var loaded = {};

    var img = document.createElement('img');
    img.className = 'tngb-img';
    img.width = 1100;
    img.height = 1100;
    img.loading = 'lazy';
    stage.innerHTML = '';
    stage.appendChild(img);

    var note = copy.querySelector('.b-note');
    if (note) note.textContent = 'In the box: Baby Wash, Kids Bubble Bath & Wash and Kids Shampoo & Conditioner, all 500mL, packed in a gift box ready to give.';

    var buy = document.createElement('div');
    buy.className = 'tngb-buy';
    buy.innerHTML =
      '<div class="tngb-scents" role="group" aria-label="Baby Wash scent"></div>' +
      '<div class="tngb-po"></div>' +
      '<button type="button" class="btn btn-primary tngb-add">Add to cart</button>' +
      '<div class="tngb-links"><a class="view-link tngb-view" href="#">View product</a></div>' +
      '<p class="tngb-status" aria-live="polite"></p>';
    var scents = buy.querySelector('.tngb-scents');
    var addBtn = buy.querySelector('.tngb-add');
    var view = buy.querySelector('.tngb-view');
    var status = buy.querySelector('.tngb-status');

    GIFT_BOXES.forEach(function (g) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tngb-scent';
      b.setAttribute('data-key', g.key);
      b.textContent = g.label;
      scents.appendChild(b);
    });

    var po = purchaseOptions({
      onceCents: 5095,
      plans: {},
      subLabel: 'Subscribe',
      note: 'Delivered every 4, 8 or 12 weeks at the gift box price. Skip, change or cancel any time.',
      onChange: function (mode) { addBtn.textContent = mode === 'sub' ? 'Subscribe' : 'Add to cart'; }
    });
    buy.querySelector('.tngb-po').appendChild(po.el);

    function select(g) {
      current = g;
      img.src = g.image;
      img.alt = 'Baby Shower Gift Box, ' + g.label + ', open gift box';
      view.href = '/products/' + g.handle;
      Array.prototype.forEach.call(scents.querySelectorAll('.tngb-scent'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-key') === g.key ? 'true' : 'false');
      });
      status.textContent = '';
      var info = loaded[g.key];
      if (info) po.update(info.variant.price, info.plans);
    }

    scents.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.tngb-scent') : null;
      if (!b) return;
      GIFT_BOXES.forEach(function (g) { if (g.key === b.getAttribute('data-key')) select(g); });
    });

    addBtn.addEventListener('click', function () {
      var info = loaded[current.key];
      if (!info) { window.location.href = '/products/' + current.handle; return; }
      if (addBtn.getAttribute('data-busy') === '1') return;
      addBtn.setAttribute('data-busy', '1');
      status.textContent = '';
      var planId = po.planId();
      addToCart(info.variant.id, planId)
        .then(function () {
          status.textContent = planId ? 'Subscription added to your bag.' : 'Added to your bag.';
          showToast(planId ? 'Gift box subscription added' : 'Gift box added to your bag');
          return refreshBadge();
        })
        .catch(function () { window.location.href = '/products/' + current.handle; })
        .then(function () { addBtn.setAttribute('data-busy', '0'); });
    });

    oldActions.parentNode.replaceChild(buy, oldActions);
    select(current);

    GIFT_BOXES.forEach(function (g) {
      loadProduct(g.handle).then(function (product) {
        var v = (product.variants || [])[0];
        if (!v) return;
        loaded[g.key] = retailPlans(product, v.id);
        if (g.key === current.key) select(current);
      }).catch(function () { /* the button falls back to the product page */ });
    });
  }

  ready(function () {
    var bag = document.getElementById('bagBtn');
    var sub = document.querySelector('.toast .t-sub');
    if (sub) sub.textContent = 'Tap the bag to check out';
    refreshBadge();
    bindCardAdds();
    if (bag) {
      bag.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        window.location.href = '/cart';
      }, true);
    }
    if (BUSINESS_PAGE) return;
    injectStyles();
    setupCards();
    setupGiftBox();
  });
})();
